module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-imbee-container",
    style: ({
      backgroundColor: _vm.chat.backgroundColor
    })
  }, [_c('transition', {
    attrs: {
      "name": "imbee-fadeIn",
      "enter-active-class": "imbee-fadeInDown",
      "leave-active-class": "imbee-fadeOutUp"
    }
  }, [_c('Header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.header.show),
      expression: "header.show"
    }],
    attrs: {
      "full-screen": _vm.fullScreen,
      "text": _vm.header.text,
      "image": _vm.header.image,
      "show-image": _vm.header.showImage,
      "color": _vm.header.color,
      "font-size": _vm.header.fontSize,
      "font-family": _vm.header.fontFamily,
      "font-weight": _vm.header.fontWeight,
      "background-color": _vm.header.backgroundColor,
      "header-top": _vm.header.headerTop,
      "header-left": _vm.header.headerLeft,
      "subtitle-text": _vm.header.subtitleText,
      "subtitle-color": _vm.header.subtitleColor,
      "font-subtitle-size": _vm.header.fontSubtitleSize,
      "font-subtitle-weight": _vm.header.fontSubtitleWeight,
      "font-subtitle-family": _vm.header.fontSubtitleFamily,
      "image-size": _vm.header.imageSize,
      "subtitle-top": _vm.header.subtitleTop,
      "subtitle-left": _vm.header.subtitleLeft
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  })], 1), _vm._v(" "), (_vm.loader.show) ? _c('LoaderContainer', {
    attrs: {
      "loader": _vm.loader.type,
      "loader-color": _vm.loader.color,
      "loader-background": _vm.loader.backgroundColor
    }
  }) : _vm._e(), _vm._v(" "), _c('Content', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loader.show),
      expression: "!loader.show"
    }],
    attrs: {
      "fs": _vm.footer.show
    }
  }), _vm._v(" "), _c('Cookie-banner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cookieBanner.show),
      expression: "cookieBanner.show"
    }],
    attrs: {
      "cookieData": _vm.cookieBanner
    },
    on: {
      "closeCookieBanner": _vm.closeCookieBanner
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "imbee-fadeIn",
      "enter-active-class": "imbee-fadeInUp",
      "leave-active-class": "imbee-fadeOutDown"
    }
  }, [_c('Footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footer.show),
      expression: "footer.show"
    }]
  })], 1), _vm._v(" "), _c('ContentHumanizacion')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a923dd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
// module id = 214
// module chunks = 0 1